import { ApolloLink } from '@apollo/client'
import { Observable } from '@apollo/client/utilities'
import { getStoredLocationToken, getStoredRefreshToken } from '../storedState'
import { createUnauthorizedError } from '../graphql-client'
import { getValidAccessToken, defaultHeaders } from '../../http-client'

async function resolveRequiredTokenForRequest(operationName: string | undefined) {
  const requestRequiresRefreshToken = ['RenewToken', 'MultifactorAuthenticationCode'].includes(operationName ?? '')
  if (requestRequiresRefreshToken) {
    return getStoredRefreshToken()
  }

  const requestRequiresLocationToken = ['SubscribeNotification', 'ReportLocation'].includes(operationName ?? '')
  if(requestRequiresLocationToken) {
    return getStoredLocationToken()
  }

  return await getValidAccessToken()
}

// Ensures token is valid before sending the request
async function setRequestHeaders(operation: ApolloLink.Operation) {
  let token: string | null = null

  token = await resolveRequiredTokenForRequest(operation.operationName)

  if (!token) {
    throw new Error('Missing or expired token')
  }

  const { headers } = operation.getContext();
  operation.setContext({
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`,
      'application-id': defaultHeaders['application-id'],
      'x-device-id': defaultHeaders['x-device-id'],
    },
  })
}

function requestRequiresToken(operationName: string | undefined) {
    return !['login', 'loginClientState'].includes(operationName ?? '')
}

export const createRequestLink = () =>
  new ApolloLink(
    (operation, forward) =>
      new Observable(observer => {
        (async () => {
          try {

            if (requestRequiresToken(operation.operationName)) {
              await setRequestHeaders(operation)
            }

            if(operation.operationName === 'login'){
              const { headers } = operation.getContext()
              operation.setContext({
                  headers: {
                    ...headers,
                    'application-id': defaultHeaders['application-id'],
                    'x-device-id': defaultHeaders['x-device-id'],
                  },
              })
            }

            forward(operation).subscribe(observer)
          } catch (err) {
            const graphqlError = createUnauthorizedError()
            observer.next({ data: null, errors: [graphqlError] })
            observer.complete()
          }
        })()
      })
  )
